import React from "react";
import { Navigate } from "react-router-dom";
import { getRoleFromToken } from "../../../auth/adminEmails";
import { AdminLoginWithProviders } from "../AdminLogin/AdminLogin";
import UserDashboard from "../UserDashboard/UserDashboard";

// Single post-login destination. Reads the role straight from the JWT
// in sessionStorage so there's no stale-state race — every render sees
// what the server is going to see on the next request.
//
// admin/captain → admin app (AdminLogin). everyone else → user view.
// no token → bounce to /login.
//
// /admin is an alias for this component, so bookmarks keep working.
export default function Dashboard() {
  const token =
    typeof window !== "undefined" && window.sessionStorage
      ? window.sessionStorage.getItem("cognitoIdToken")
      : null;

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  const role = getRoleFromToken(token);
  if (role === "admin" || role === "captain") {
    return <AdminLoginWithProviders />;
  }

  return <UserDashboard />;
}
